import { Box, Stack } from "@mui/material";
import React, { useCallback } from "react";
import CampusTitle from "./CampusTitle";
import { useNavigate } from "react-router";
import StyledButton from "../../../Reuse/UI/StyledButton";
import StyleStack from "../../../Reuse/UI/StyleStack";
import { DroneBox } from "./DroneBox";

const List = (props) => {
  const navigate = useNavigate();
  const { rows } = props;
  const viewCallback = useCallback(
    (e, id) => {
      e.preventDefault();
      navigate(`./${id}`);
    },
    [navigate],
  );
  return (
    <Stack direction={"column"} gap={1}>
      {rows.map((row, rowIndex) => (
        <StyleStack
          key={row.id}
          direction="row"
          gap={1.5}
          sx={{
            padding: 1,
            // flexDirection: "row",
          }}
        >
          <Stack
            direction={"row"}
            sx={{
              gap: 2,
              alignItems: "center",
              flexGrow: 1,
              width: "calc(100% - 81px)",
            }}
          >
            <Box
              sx={{
                width: 80,
                minWidth: 80,
                height: 56,
                borderRadius: 1,
                overflow: "hidden",
                background: "#000000",
              }}
            >
              <img
                style={{ width: "100%", height: "100%" }}
                src={row.icon_url}
                alt={row.name}
              />
            </Box>
            <CampusTitle name={row.name} index={row.campus_number} />
            <DroneBox
              availableDoors={row.availableDoors}
              available_doors={row.available_doors}
              availableDrone={row.availableDrone}
              available_drones={row.available_drones}
              unavailableDrone={row.unavailableDrone}
              unavailable_drones={row.unavailable_drones}
            />
          </Stack>
          <StyledButton
            variant="outlined"
            onClick={(e) => viewCallback(e, row.id)}
          >
            View
          </StyledButton>
        </StyleStack>
      ))}
    </Stack>
  );
};

export default React.memo(List);
